<template>
  <v-layout row wrap align-center class="pointer" py-2>
    <v-flex xs8 @click="clicked">
      <v-layout row wrap>
        <v-flex xs2 class="text-xs-center">
          <v-icon v-if="isSelected" color="primary" class="mr-1">mdi-check</v-icon>
          <v-icon v-else class="mr-1">mdi-blank</v-icon>
        </v-flex>
        <v-flex xs10>
          <div v-for="(subRow, i) in row.rows" :key="`flist-${row.id}-${i}`">
            <v-tooltip top max-width="300" v-if="subRow && subRow.length > 90">
              <template slot="activator">
                <span>{{subRow.substring(0,90) + '...'}}</span>
              </template>
              <span>{{subRow}}</span>
            </v-tooltip>
            <span v-else>
              {{subRow}}
            </span>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs2 v-if="showDefaultOption">
      <v-checkbox v-model="isDefaultSearch"
                  hide-details
                  color="primary"
                  class="checkbox" />
    </v-flex>
    <v-flex xs2 v-if="showDeleteOption" class="text-xs-center">
      <v-btn flat icon @click="deleteFilter(row)" class="ma-0">
        <v-icon size="20px">stream-delete</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  DELETE_SAVED_FILTER,
  SAVE_UPDATE_MY_FILTER,
  UPDATE_DEFAULT_FILTER,
  UPDATE_MY_FILTER
} from '../../store/action-types'
import { mapActions, mapMutations } from 'vuex'
import { SET_SELECTED_FILTER_ID } from '../../store/mutation-types'

export default {
  name: 'my-filter-list-row',
  props: {
    row: {
      type: Object,
      required: true
    },
    idSet: {
      type: Set,
      required: true
    },
    deleteFilter: {
      type: Function,
      required: true
    },
    selectedButtonText: {
      type: Function,
      required: true
    },
    showDefaultOption: {
      type: Boolean,
      required: true
    },
    showDeleteOption: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      setSelectedFilterId: SET_SELECTED_FILTER_ID
    }),
    clicked () {
      // if clicked, pass button text
      this.selectedButtonText(this.row.rows.toString())
      this.$emit('selected', {id: this.row.id, selected: !this.isSelected})
      this.setSelectedFilterId(this.row.id)
    },
    ...mapActions({
      saveMyFilter: SAVE_UPDATE_MY_FILTER,
      updateDefaultMyFilter: UPDATE_DEFAULT_FILTER,
      updateMyFilter: UPDATE_MY_FILTER,
      deleteSavedFilter: DELETE_SAVED_FILTER
    })
  },
  computed: {
    isSelected () {
      return this.idSet.has(this.row.id)
    },
    isDefaultSearch: {
      get () {
        return this.row.defaultSearch
      },
      set (value) {
        if (value && !this.idSet.has(this.row.id)) {
          // if set default, pass button text
          this.selectedButtonText(this.row.rows.toString())
          this.updateDefaultMyFilter({id: this.row.id, isDefault: value})
          // this.saveMyFilter({
          //   description: this.row.rows.toString(),
          //   defaultSearch: value,
          //   id: this.row.id,
          //   defaultAction: true})
        } else {
          this.updateDefaultMyFilter({id: this.row.id, isDefault: value})
          // this.updateMyFilter({
          //   description: this.row.rows.toString(),
          //   defaultSearch: value,
          //   id: this.row.id})
        }
      }
    }
  }
}
</script>

<style scoped>
  .checkbox {
    width: 24px;
    height: 30px;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/MyFilterListRow.vue